var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusUser = function SvgPlusUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.458 24.5c0 5.72 4.636 10.356 10.355 10.356 5.72 0 10.356-4.637 10.356-10.356 0-5.72-4.636-10.356-10.356-10.356-5.719 0-10.355 4.637-10.355 10.356Zm-1.145 0c0-6.351 5.15-11.5 11.5-11.5 6.352 0 11.5 5.149 11.5 11.5S19.166 36 12.814 36c-6.35 0-11.5-5.149-11.5-11.5ZM4.444 38.031a9.095 9.095 0 0 0-1.95 4.7l-.122 1.11h20.883l-.123-1.11a9.095 9.095 0 0 0-1.95-4.7c.33-.194.646-.406.95-.634a10.277 10.277 0 0 1 2.181 6.354c0 .7-.558 1.249-1.224 1.249H2.538a1.237 1.237 0 0 1-1.226-1.25c0-2.401.816-4.607 2.182-6.353.304.228.62.44.95.634Z",
    fill: "var(--c-blue)",
    stroke: "var(--c-blue)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.444 38.031c-.29.362-.553.746-.787 1.15l.728.42-.728-.42a9.1 9.1 0 0 0-1.162 3.55l-.123 1.11h20.883l-.123-1.11a9.1 9.1 0 0 0-1.95-4.7c.33-.194.646-.406.95-.634a10.275 10.275 0 0 1 2.126 5.27l.994-.102-.994.103c.037.355.056.717.056 1.083 0 .7-.56 1.249-1.226 1.249H2.538a1.237 1.237 0 0 1-1.225-1.25 10.262 10.262 0 0 1 2.181-6.354c.305.23.622.441.95.635Z",
    fill: "var(--c-blue)",
    stroke: "var(--c-blue)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.314 1.6c0-.884.671-1.6 1.5-1.6.828 0 1.5.716 1.5 1.6v12.8c0 .884-.672 1.6-1.5 1.6-.829 0-1.5-.716-1.5-1.6V1.6Z",
    fill: "var(--c-white)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.313 1.6v12.8c0 .884-.671 1.6-1.5 1.6-.828 0-1.5-.716-1.5-1.6V1.6c0-.884.672-1.6 1.5-1.6.829 0 1.5.716 1.5 1.6Z",
    fill: "var(--c-blue2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.814 9a1.5 1.5 0 1 1 0-3h12a1.5 1.5 0 0 1 0 3h-12Z",
    fill: "var(--c-white)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.814 6h12a1.5 1.5 0 0 1 0 3h-12a1.5 1.5 0 1 1 0-3Z",
    fill: "var(--c-blue2)"
  })));
};
export default SvgPlusUser;